import { useEffect, useRef } from "react";

const BASE_URL = `${window.location.origin}`;

declare global {
  interface Window {
    Trustpilot?: any;
  }
}

export const TrustPilotWidget = () => {
  const trustbox = document.getElementById("trustbox");

  if (trustbox) {
    window.Trustpilot.loadFromElement(trustbox);
  }

  const ref = useRef(null);

  useEffect(() => {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);

  const isCharlesHurst = BASE_URL.includes("charleshurst");
  const LookersPath = "https://uk.trustpilot.com/review/www.lookers.co.uk";
  const CharlesHurstPath =
    "https://uk.trustpilot.com/review/www.charleshurstgroup.co.uk";

  return (
    <div
      ref={ref}
      className="trustpilot-widget"
      data-locale="en-GB"
      data-template-id="5419b732fbfb950b10de65e5"
      data-businessunit-id={
        isCharlesHurst ? "4be74d72000064000509c45b" : "55112a080000ff00057e4094"
      }
      data-style-height="24px"
      data-style-width="100%"
      data-theme="light"
    >
      <a
        href={isCharlesHurst ? CharlesHurstPath : LookersPath}
        target="_blank"
        rel="noreferrer"
      >
        Trustpilot
      </a>
    </div>
  );
};
